import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getLabelsBySelection = (candidate, selection) => async (dispatch) => {
    dispatch({
        type: 'LABEL_LOADING'
    })
    try {
        const { data, status } = await Axios.get(`/api/client/label/${candidate}/selection/${selection}`, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'LABEL_GET_SUCCESS',
                payload: data.labels
            })
        } else {
            dispatch({
                type: 'LABEL_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'LABEL_NOT_LOADING'
        })
    }
}

export const registerLabels = (labelData) => async (dispatch) => {
    dispatch({
        type: 'LABEL_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/label/register', labelData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'LABEL_REGISTER_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'LABEL_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'LABEL_NOT_LOADING'
        })
    }
}